import React, { useEffect, useState } from "react";
import styles from "./login.module.css";
import { Row, Col, Spinner } from "react-bootstrap";
import { getCliente, getClienteNota, } from "../../service/api.jsx";
import { Forms } from "../../components/Forms/index.jsx";
import { useNavigate } from "react-router-dom";
import { SiAppstore, SiGoogleplay } from "react-icons/si";


function Login() {

  const navigate = useNavigate();

  const [cnpj, setCnpj] = useState("");
  const [codcli, setCodcli] = useState("");
  const [rangeData, setRangeData] = useState("15");
  const [page, setPage] = useState(false);
  const [alert, setAlert] = useState(false);
  const [alertData, setAlertData] = useState(false);
  const [alertNota, setAlertNota] = useState(false);
  const [nota, setNota] = useState([]);
  const [loading, setLoading] = useState(false);

  async function searchCliente() {
    try {
      const cnpjWithoutFormatting = cnpj.replace(/\D/g, "");
      const response = await getCliente(cnpjWithoutFormatting);

      const validaResponse =
        response?.data?.cnpj && response.data.cnpj.length > 0;

      if (!validaResponse) {
        setAlert(true);
        return;
      }

      setCodcli(response.data.cnpj[0].codcli);

      if (rangeData === "") {
        setAlertData(true);
      } else {
        setPage(true);
      }
    } catch (error) {
      setAlert(true);
    }
  }

  useEffect(() => {
    const fetchClienteNota = async () => {
      setLoading(true);
      try {
        const response = await getClienteNota(codcli, rangeData);

        if (response.data.result && Array.isArray(response.data.result) && response.data.result.length > 0) {
          setNota(response.data.result);

          setTimeout(() => {
            navigate("/notas", { state: { responseData: response.data.result } });
          }, 250);

        } else {
          setNota([]);
          setAlertNota(true);
          setLoading(false);
          window.alert("Nenhuma nota encontrada para o cliente nesse período.");
        }
      } catch (error) {
        setNota([]);
        setAlertNota(true);
        alert("Erro ao buscar notas fiscais.");
      } finally {
        setLoading(false);
      }
    };

    if (page && codcli) {
      fetchClienteNota();
    }
  }, [page, codcli, rangeData, navigate]);

  return (
    <div className={styles["background-div"]}>
      <Row>
        <Col xl={8} className={styles["hide-on-mobile"]}>
          <Row>
            <Col xl={12} xs={6} className={styles["logo-container"]}>
              <img src="/assets/images/logo_brasal.png" alt="Logo Brasal" className={styles["logo-brasal"]} />
            </Col>
            <Col xl={12} xs={6} className={styles["logo-container"]}>
              <img src="/assets/images/bg-image.png" className={styles["bg-image"]} alt="Fundo Brasal" />
            </Col>
          </Row>
        </Col>
        <Col xl={4} className={styles["col-form"]}>
          {loading ? (
            <div className={styles["loading-container"]}>
              <img src="/assets/images/logo.png" alt="Logo NF-SIG" className={styles["logoLoading"]} />
              <h5 className={styles["titulo"]}>Consulta de Notas Fiscais e Boletos</h5>
              <Spinner animation="border" variant="danger" />
              <p className={styles["info"]}>Carregando suas notas fiscais...<br></br>Aguarde um momento.</p>

              
            </div>
          ) : (
            <Forms
              cnpj={cnpj}
              setCnpj={setCnpj}              
              alert={alert}
              alertData={alertData}
              searchCliente={searchCliente}
            />
          )}

          <div className={`${styles["store-cta-card"]} mt-3`} role="note" aria-label="Baixe o app Conecta Brasal">
            <p className={styles["store-cta-text"]}>
              Baixe o aplicativo <strong>Conecta Brasal</strong> e tenha um histórico <strong>mais completo</strong> de notas fiscais e boletos.
            </p>
            <div className="d-flex justify-content-center gap-3 flex-wrap mt-3">
              <a
                href="https://apps.apple.com/br/app/conecta-brasal/id6736531681?l"
                target="_blank"
                rel="noopener noreferrer"
                style={{ backgroundColor: "#0d6efd", color: "#fff" }}
                className="btn btn-sm d-inline-flex align-items-center gap-2"
              >
                <SiAppstore size={18} />
                App Store
              </a>

              <a
                href="https://play.google.com/store/apps/details?id=com.conecta.brasal"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-success btn-sm d-inline-flex align-items-center gap-2"
              >
                <SiGoogleplay size={18} />
                Play Store
              </a>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default Login;